import i18n from '@/i18n/i18n'
import BankService from '@/services/admin/BankService.js'
import { build_query, errorMessage } from '@/utilities/helpers.js'
import money from '@/utilities/money'

const { t } = i18n.global

export const allowedFilters = ['is_collection_bank', 'type']

export const namespaced = true

export const state = {
  banks: [],
  bank: {},
  bankAccount: {},
  financialBank: null,
  billBank: null,
  payment: {},
  bankAccounts: [],
  correspondentBanks: [],
  correspondentBank: null
}

export const mutations = {
  SET_BANKS(state, banks) {
    state.banks = banks.data
  },
  SET_BANK(state, bank) {
    if (bank.data) {
      bank.data.protest_expense = parseFloat(money.ofMinor(bank.data.protest_expense).getAmount())
        .toString()
        .replace('.', ',')
      bank.data.protest_expense_for_guarantor_order = parseFloat(money.ofMinor(bank.data.protest_expense_for_guarantor_order).getAmount())
        .toString()
        .replace('.', ',')
      bank.data.protest_withdraw_expense = parseFloat(money.ofMinor(bank.data.protest_withdraw_expense).getAmount())
        .toString()
        .replace('.', ',')
      bank.data.protest_withdraw_expense_for_guarantor_order = parseFloat(
        money.ofMinor(bank.data.protest_withdraw_expense_for_guarantor_order).getAmount()
      )
        .toString()
        .replace('.', ',')
    }
    state.bank = bank.data
  },
  ADD_BANK(state, banks) {
    state.banks.push(banks)
  },
  SET_FINANCIAL_BANK(state, financialBank) {
    state.financialBank = financialBank.data
  },
  SET_BILL_BANK(state, billBank) {
    state.billBank = billBank.data
  },
  SET_PAYMENT(state, payment) {
    state.payment = payment
  },
  SET_BANK_ACCOUNTS(state, bankAccounts) {
    state.bankAccounts = bankAccounts.data
  },
  SET_BANK_ACCOUNT(state, bankAccount) {
    state.bankAccount = bankAccount.data
  },
  DELETE_BANK_ACCOUNT(state, bankAccountId) {
    state.bankAccounts = state.bankAccounts.filter(account => {
      return account.id !== bankAccountId
    })
  },
  SET_CORRESPONDENT_BANKS(state, correspondentBanks) {
    state.correspondentBanks = correspondentBanks.data
  },
  SET_CORRESPONDENT_BANK(state, correspondentBank) {
    state.correspondentBank = correspondentBank.data
  },
  DELETE_CORRESPONDENT_BANK(state, correspondentBankId) {
    state.correspondentBanks = state.correspondentBanks.filter(bank => {
      return bank.id !== correspondentBankId
    })
  }
}

export const actions = {
  getBanks({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)

    return new Promise((resolve, reject) => {
      BankService.getBanks(newQuery)
        .then(response => {
          commit('SET_BANKS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.bank_infos')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBank({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      BankService.getBank(id)
        .then(response => {
          commit('SET_BANK', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.bank_infos')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBankAccount({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.getBankAccount(params.bank_id, params.account_id)
        .then(response => {
          commit('SET_BANK_ACCOUNT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.bank_account_infos')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBankAccounts({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.getBankAccounts(params)
        .then(response => {
          commit('SET_BANK_ACCOUNTS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.bank_account_infos')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBankAccountsByBank({ commit, dispatch }, bankId) {
    return new Promise((resolve, reject) => {
      BankService.getBankAccountsByBank(bankId)
        .then(response => {
          commit('SET_BANK_ACCOUNTS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.bank_account_infos')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createBank({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.createBank(params.bank)
        .then(response => {
          commit('ADD_BANK', response)
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.bank.bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.bank.bank')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateBank({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.updateBank(params.bank.id, params.bank)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.bank.bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.bank.bank')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  uploadLogo({ dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.uploadLogo(params.bank_id, params.form)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.bank.bank_logo')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.uploading_error', {
                element: t('store.admin.bank.bank_logo')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getFinancialBank({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      BankService.getFinancialBank(newQuery)
        .then(response => {
          commit('SET_FINANCIAL_BANK', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.banks')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getFinancialBankOptions({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      BankService.getFinancialBank(newQuery)
        .then(response => {
          const bankIdSortedList = response.data.map(bank => bank.id).sort((a, b) => a - b)

          response.data.unshift({
            id: bankIdSortedList[bankIdSortedList.length - 1] + 1,
            name: t('store.shared.is_none', {
              element: t('store.admin.bank.financial_bank')
            }),
            eft_code: 0,
            is_collection_bank: true
          })
          commit('SET_FINANCIAL_BANK', response)
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.banks')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getBillBank({ commit, dispatch }, query) {
    let newQuery = build_query(query, allowedFilters)
    return new Promise((resolve, reject) => {
      BankService.getBillBank(newQuery)
        .then(response => {
          commit('SET_BILL_BANK', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.banks')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getPayment({ commit, dispatch }, id) {
    return new Promise((resolve, reject) => {
      BankService.getPayment(id)
        .then(response => {
          commit('SET_PAYMENT', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.fetching_problem', {
                element: t('store.admin.bank.payment_info')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  editBanks({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.editBanks(params.orderId, params.paymentId, params.params)
        .then(response => {
          commit('SET_PAYMENT', response)

          const notification = {
            type: 'success',
            message: t('store.shared.saved', {
              element: t('views.admin.orders.farmer_payment_information.financa_and_bank_info')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.update_error', {
              element: t('store.admin.bank.payment_info')
            }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createBankAccount({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.createBankAccount(params.bank_id, { ...params })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.bank.bank_account')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.adding_problem', {
                element: t('store.admin.bank.bank_account')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateBankAccount({ dispatch }, bankAccount) {
    return new Promise((resolve, reject) => {
      BankService.updateBankAccount(bankAccount.bank_id, bankAccount.id, { ...bankAccount })
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.bank.bank_account')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.update_error', {
                element: t('store.admin.bank.bank_account')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteBankAccount({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.deleteBankAccount(params.bank_id, params.account_id)
        .then(response => {
          commit('DELETE_BANK_ACCOUNT', params.account_id)
          const notification = {
            type: 'success',
            message: t('store.shared.removed', {
              element: t('store.admin.bank.bank_account')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message:
              t('store.shared.delete_error', {
                element: t('store.admin.bank.bank_account')
              }) + errorMessage(err)
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCorrespondentBanks({ commit, dispatch }, bankId) {
    return new Promise((resolve, reject) => {
      BankService.getCorrespondentBanks(bankId)
        .then(response => {
          commit('SET_CORRESPONDENT_BANKS', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.bank.correspondent_banks')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  getCorrespondentBank({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.getCorrespondentBank(params.beneficiary_bank_id, params.correspondent_bank_id)
        .then(response => {
          commit('SET_CORRESPONDENT_BANK', response)
          resolve(response)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.fetching_problem', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  createCorrespondentBank({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.createCorrespondentBank(params.bank_id, params.data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.added', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: `${t('store.shared.adding_problem', {
              element: t('store.admin.bank.correspondent_bank')
            })} ${errorMessage(err)}`
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  updateCorrespondentBank({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.updateCorrespondentBank(params.beneficiary_bank_id, params.correspondent_bank_id, params.data)
        .then(response => {
          const notification = {
            type: 'success',
            message: t('store.shared.updated', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.update_error', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  },
  deleteCorrespondentBank({ commit, dispatch }, params) {
    return new Promise((resolve, reject) => {
      BankService.deleteCorrespondentBank(params.beneficiary_bank_id, params.correspondent_bank_id)
        .then(response => {
          commit('DELETE_CORRESPONDENT_BANK', params.correspondent_bank_id)
          const notification = {
            type: 'success',
            message: t('store.shared.removed', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          resolve(response.data)
        })
        .catch(err => {
          const notification = {
            type: 'danger',
            message: t('store.shared.delete_error', {
              element: t('store.admin.bank.correspondent_bank')
            })
          }
          dispatch('notification/add', notification, {
            root: true
          })
          reject(err)
        })
    })
  }
}
